module.exports = __webpack_public_path__ + "static/media/referal.ba9784ab.svg";